const ArticleTypesEnum = Object.freeze({
  YOU: 0,
  TRADER: 1
})

export { ArticleTypesEnum }
